var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.steps.length > 1)?_c('div',{class:_vm.$style.wizard},[_c('div',{class:_vm.$style.wizardRow},_vm._l((_vm.steps),function(step){return _c('WizardStep',{key:step.id,style:(_vm.stepStyle),attrs:{"step":step},on:{"onClick":_vm.wizardStepClick}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }